import { render, staticRenderFns } from "./LoadingCard.vue?vue&type=template&id=54855caa&"
import script from "./LoadingCard.vue?vue&type=script&lang=js&"
export * from "./LoadingCard.vue?vue&type=script&lang=js&"
import style0 from "./LoadingCard.vue?vue&type=style&index=0&id=54855caa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports